import React from 'react';
import '../../../common.scss';
import Messaging from '../../../../../../context/Messaging';

interface NoStudentsMessageProps {
  activeFilter: string; // Represents the currently active filter
  activeFilterDisplayName: string; // Display name of the active filter
  isPreviewMode: boolean; // Indicates if the component is in preview mode
  SECTION_3_NAME: string; // Name of the section for Section 3
}

const NoStudentsMessage: React.FC<NoStudentsMessageProps> = ({
  activeFilter,
  activeFilterDisplayName,
  isPreviewMode,
  SECTION_3_NAME,
}) => {
  const noStudentsInRoom = () => (
    <div
      id='monitor-student-list-empty'
      className='px-5 py-5 mb-4 digital-heading--h3 text-center'
      role='region'
      aria-label='Monitor Students information'
    >
      No students are assigned to this room.
    </div>
  );

  const noStudentsInRoomPreview = () => (
    <div
      className='no-student-text-ctn'
      id='preview-monitor-no-student-content'
      role='region'
      aria-label='Monitor Students information'
    >
      <Messaging dynamic preview section='wizard.monitor' />
    </div>
  );

  const noStudentsInRoomWithFilter = () => (
    <div
      id='active-filter-noMatch'
      className='px-5 py-5 mb-4 digital-heading--h3 text-center'
      role='region'
      aria-label='Filtered Results'
    >
      No students match the selected filter.
    </div>
  );

  const section3Content = () => (
    <div className='no-student-text-ctn'>
      <div className='no-student-text-item' id='section-3-no-student-item'>
        <div className='digital-heading--h3'>
          Delaware, Michigan, New Hampshire State Administrations and DoDEA Schools
        </div>
        <p className='no-student-text'>
          If your school participates in a state administration or your school is part of DoDEA, students in your room
          will be listed here when they start Section 3, the SAT Essay.
        </p>
      </div>
      <div className='no-student-text-item' id='section-3-no-student-item'>
        <div className='digital-heading--h3'>All Other Administrations</div>
        <p className='no-student-text'>
          Your students do not complete Section 3. Their answers will be submitted at the end of Section 2.
        </p>
      </div>
    </div>
  );

  const renderNoStudentOrMatchingFilterText = () => {
    if (isPreviewMode) return noStudentsInRoomPreview();
    if (activeFilterDisplayName === SECTION_3_NAME) return section3Content();
    return activeFilter ? noStudentsInRoomWithFilter() : noStudentsInRoom();
  };

  return renderNoStudentOrMatchingFilterText();
};

export default NoStudentsMessage;
